import { render, staticRenderFns } from "./CardRoom.vue?vue&type=template&id=72165e7f&scoped=true"
import script from "./CardRoom.vue?vue&type=script&lang=js"
export * from "./CardRoom.vue?vue&type=script&lang=js"
import style0 from "./CardRoom.vue?vue&type=style&index=0&id=72165e7f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72165e7f",
  null
  
)

export default component.exports